<template>
  <div class="login-page items-center justify-center">
    <v-card :loading="loading" class="mx-auto item-card pa-md-12 pa-5">
      <warnningComponent
        v-bind:textInfo.sync="textWarning"
        v-bind:typestatus.sync="typeWarning"
        v-bind:alert.sync="showWarnnig"
      ></warnningComponent>
      <div class="logo mb-5">
        <v-img src="../../assets/ssru-logo.png"></v-img>
      </div>
      <div class="titile my-5">
        <v-card-title
          primary-title
          class="headline justify-center pa-0 font-weight-bold"
        >มหาวิทยาลัยราชภัฏสวนสุนันทา</v-card-title>
        <!-- <p
          class="caption text-center my-5"
        >Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>-->
      </div>
      <v-form ref="form" class="px-5" v-model="valid">
        <p class="font-weight-light">ข้อมูลพื้นฐาน</p>
        <v-row>
          <v-col lg="6" md="6" sm="6" cols="12" class="colStlye">
            <p class="labelTitleField">
              เพศ (Gender)
              <span class="red--text">*</span>
            </p>
            <v-autocomplete
              v-model="selectedGender"
              :items="genders"
              item-text="text"
              item-value="value"
              outlined
              rounded
              placeholder="กรุณาเลือกเพศ"
              :rules="genderRules"
            ></v-autocomplete>
          </v-col>
          <v-col lg="6" md="6" sm="6" cols="12" class="colStlye">
            <p class="labelTitleField">
              กลุ่มผู้ใช้ (Group)
              <span class="red--text">*</span>
            </p>
            <v-autocomplete
              v-model="selection"
              :rules="groupRules"
              :items="arrayGroup"
              item-text="title"
              item-value="_id"
              append-icon="search"
              chips
              small-chips
              multiple
              rounded
              outlined
              placeholder="กรุณาเลือกกลุ่มผู้ใช้"
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeByUser(data.item)"
                >{{ data.item.title }}</v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="6" md="6" sm="6" cols="12" class="colStlye">
            <p class="labelTitleField">
              ชื่อจริง (First Name)
              <span class="red--text">*</span>
            </p>
            <v-text-field
              outlined
              rounded
              v-model="firstName"
              :rules="firstNameRules"
              placeholder="กรุณากรอกชื่อจริง"
              required
              clearable
              class="md-w-100 m-auto"
            ></v-text-field>
          </v-col>
          <v-col lg="6" md="6" sm="6" cols="12" class="colStlye">
            <p class="labelTitleField">
              นามสกุล (Last Name)
              <span class="red--text">*</span>
            </p>
            <v-text-field
              outlined
              rounded
              v-model="lastName"
              :rules="lastNameRules"
              placeholder="กรุณากรอกนามสกุล"
              required
              clearable
              class="md-w-100 m-auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider class="mb-5"></v-divider>
        <v-row>
          <v-col lg="6" md="6" sm="6" cols="12" class="colStlye">
            <p class="labelTitleField">รูปโปรไฟล์</p>
            <v-file-input
              v-model="imageFile"
              @change="preview"
              rounded
              outlined
              dense
              show-size
              accept="image/png, image/jpeg, image/bmp"
              :label="imgPreview ? 'เลือกรูปภาพใหม่' : 'เลือกรูปภาพ'"
              prepend-icon="mdi-camera"
            ></v-file-input>
          </v-col>
          <v-col lg="6" md="6" sm="6" cols="12" class="colStlye">
            <v-card class="rounded-card" :color="`grey lighten-2`" elevation="3">
              <!-- <div class="img-padding" align="center" justify="center"> -->
              <!-- <v-avatar :color="`grey lighten-2`" elevation="3" size="200"> -->
              <v-img class="rounded-card" :src="imgPreview" aspect-ratio="1.7">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0">
                    <v-icon
                      v-if="!imageReady"
                      class="mx-auto"
                      width="240px"
                      height="240px"
                      elevation="3"
                      size="200"
                      color="white"
                    >mdi-account-circle</v-icon>
                  </v-row>
                </template>
              </v-img>
              <!-- </v-avatar> -->
              <!-- </div> -->
            </v-card>
          </v-col>
        </v-row>
        <v-divider class="mb-5 mt-5"></v-divider>
        <p class="font-weight-light">ข้อมูลสำหรับเข้าใช้ระบบ</p>
        <v-row>
          <v-col lg="6" md="6" sm="6" cols="12" class="colStlye">
            <p class="labelTitleField">
              อีเมล (E-mail)
              <span class="red--text">*</span>
            </p>
            <v-text-field
              outlined
              rounded
              v-model="email"
              type="email"
              :rules="emailRules"
              placeholder="กรุณากรอกอีเมล"
              required
              clearable
              class="md-w-100 m-auto"
            ></v-text-field>
          </v-col>
          <v-col lg="6" md="6" sm="6" cols="12" class="colStlye">
            <p class="labelTitleField">
              ชื่อผู้ใช้ (Username)
              <span class="red--text">*</span>
            </p>
            <v-text-field
              outlined
              rounded
              v-model="username"
              type="text"
              :rules="userNameRules"
              placeholder="กรุณากรอกชื่อผู้ใช้"
              required
              clearable
              class="md-w-100 m-auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="6" md="6" sm="6" cols="12" class="colStlye">
            <p class="labelTitleField">
              รหัสผ่าน (Password)
              <span class="red--text">*</span>
            </p>
            <v-text-field
              :type="showPassword ? 'text' : 'password'"
              rounded
              outlined
              clearable
              :rules="passwordRules"
              placeholder="รหัสผ่าน"
              required
              autocomplete="password"
              v-model="password"
              :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-col>
          <v-col lg="6" md="6" sm="6" cols="12" class="colStlye">
            <p class="labelTitleField">
              ยืนยันรหัสผ่าน (Confirm Password)
              <span class="red--text">*</span>
            </p>
            <v-text-field
              :type="showComfirmPassword ? 'text' : 'password'"
              rounded
              outlined
              autocomplete="password"
              required
              id="confirm-password"
              clearable
              :rules="conFirmPasswordRules"
              placeholder="ยืนยันรหัสผ่าน"
              v-model="confirmPassword"
              :append-icon="!showComfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showComfirmPassword = !showComfirmPassword"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider class="mb-5"></v-divider>
        <div class="text-center mt-2 mb-8">
          <v-btn
            color="primary"
            class="md-w-40 xs-full-width"
            :disabled="!valid"
            large
            rounded
            @click="validate"
          >Register</v-btn>
        </div>
      </v-form>
    </v-card>
    <v-dialog v-model="dialogAddSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">สมัครสมาชิกสำเร็จ</v-card-title>

        <v-card-text>เราได้บันทึกข้อมูลของคุณแล้ว</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogAddSuccess = false, dialogFormUser = false"
          >เสร็จสิ้น</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddFail" max-width="450">
      <v-card>
        <v-card-title class="headline">สมัครสมาชิกไม่สำเร็จ</v-card-title>

        <v-card-text>เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error darken-1" text @click="dialogAddFail = false">ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUsernameDuplicade" max-width="450">
      <v-card>
        <v-card-title class="headline">สมัครสมาชิกไม่สำเร็จ</v-card-title>

        <v-card-text>อีเมล หรือชื่อผู้ใช้นี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่น</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" text @click="dialogUsernameDuplicade = false">ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { register } from "@/service/account/register";
import { getUserGroup } from "@/service/account/manageUserGroup";
import { uploadImagePublic } from "@/service/upload/upload";
export default {
  name: "register",
  data() {
    return {
      valid: true,
      dialogFormUser: false,
      checkboxPassword: false,
      scrollBottom: false,
      showPassword: false,
      showComfirmPassword: false,

      firstName: "",
      lastName: "",
      selectedGender: "",
      email: "",
      username: "",
      password: "",
      confirmPassword: "",

      imgURL: "",
      imgPreview: "",
      imageFile: null,
      imageReady: false,

      genders: [
        {
          text: "ชาย",
          value: "male"
        },
        {
          text: "หญิง",
          value: "female"
        }
      ],

      dialogAddSuccess: false,
      dialogAddFail: false,
      dialogUsernameDuplicade: false,

      groupUsers: [],
      filterGroupResult: [],
      selectionGroup: [],
      selection: [],
      filterGroup: "",
      group: [],
      arrayGroup: [],
      selectedGroup: [],
      company: "5e9696a15c4b9e5c05cda03a",

      imageRules: [
        v => !!v || this.$vuetify.lang.t("$vuetify.plsUploadPhoto"),
      v => v.size < 20000000 || this.$vuetify.lang.t("$vuetify.plsChooseUnder20MB")
      ],
      firstNameRules: [v => !!v || "กรุณากรอกชื่อจริง"],
      lastNameRules: [v => !!v || "กรุณากรอกนามสกุล"],
      groupRules: [v => v.length > 0 || "กรุณาระบุกลุ่ม"],
      genderRules: [v => !!v || "กรุณาระบุเพศ"],
      userNameRules: [v => !!v || "กรุณากรอกชื่อผู้ใช้งาน"],
      passwordRules: [
        v => !!v || "กรุณากรอกรหัสผ่าน",
        v => v.length >= 8 || "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป"
      ],
      conFirmPasswordRules: [
        v => v.length >= 8 || "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป",
        v => (!!v && v === this.password) || "กรุณากรอกรหัสผ่านให้ตรงกัน"
      ],

      emailRules: [
        v => !!v || "กรุณากรอกอีเมล",
        v => /.+@.+\..+/.test(v) || "กรุณากรอกให้อยู่ในรูปแบบอีเมล"
      ]
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    removeByUser(item) {
      const index = this.selection.indexOf(item._id);
      if (index >= 0) this.selection.splice(index, 1);
    },
    async initialize() {
      this.selectedGroup = [];

      await this.getUserGroupList();
    },
    async getUserGroupList() {
      let result = await getUserGroup({
        company: this.company
      });
      this.groupUsers = [];
      this.arrayGroup = [];
      await result.forEach(async group => {
        group.child_User_Group.length === 0
          ? await this.arrayGroup.push({
              title: group.title,
              _id: group._id
            })
          : null;
        group.child_User_Group.forEach(async child => {
          child.child_User_Group.length === 0
            ? await this.arrayGroup.push({
                title: group.title + " -> " + child.title,
                _id: child._id
              })
            : null;
          child.child_User_Group.forEach(async lastChild => {
            await this.arrayGroup.push({
              title:
                group.title + " -> " + child.title + " -> " + lastChild.title,
              _id: lastChild._id
            });
          });
        });
      });
      this.groupUsers = result;
    },
    async uploadImg(image) {
      let status = await uploadImagePublic("user", image);
      return status;
    },
    async preview() {
      if (this.imageFile != null) {
        this.imgURL = await this.uploadImg(this.imageFile);
        this.imgPreview = this.imgURL;
        this.imageReady = true;
        console.log("UPLOADED IMAGE:", this.imgPreview);
      } else {
        this.imageReady = false;
      }
    },
    async validate() {
      // this.loading = true;
      if (this.$refs.form.validate()) {
        if (this.imgPreview) {
          this.preview();
        }

        let result = await register({
          username: this.username,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          image: this.imgURL,
          studentCode: "",
          gender: this.selectedGender,
          email: this.email,
          identificationNumber: "",
          companies: [this.company],
          user_groups: this.selection
        });

        console.log(result);

        if (result.message == "username or email duplicade") {
          this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
        } else if (result.code == 403) {
          this.dialogAddFail = true; //กรณี error อื่น
        } else {
          this.$router.push({ path: "/register-success" });
        }
      } else {
        console.log("not pass");
      }
    }
  }
};
</script>
<style scoped>
.colStlye {
  padding-top: unset;
  padding-bottom: unset;
}
.labelTitleField {
  font-size: 15px;
  color: rgb(109, 109, 109);
}
.logo {
  max-width: 150px;
  /* width: 20%; */
  margin: 0 auto;
}
.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-card {
  width: 30%;
  min-height: 300px;
}

.md-w-100 {
  width: 100%;
}
.md-w-40 {
  width: 40%;
}
.or-line {
  width: 74%;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
  line-height: 0.1em;
  margin: 10px auto 20px;
}
.or-line span {
  background: #fff;
  padding: 0 30px;
  color: #e0e0e0;
}
.w-auto {
  width: auto !important;
}
.m-auto {
  margin: 0 auto !important;
}
.md-position-bottom-0 {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}
.md-position-relative {
  position: relative !important;
}
.center {
  text-align: center;
}

@media only screen and (max-width: 768px) {
  .or-line {
    width: 94%;
  }
  .item-card {
    width: 100%;
    /* min-height: 90%; */
  }
  .login-page {
    height: 100%;
    align-items: unset;
  }
  .xs-position-unset {
    position: unset !important;
  }
  .xs-full-width {
    width: 100% !important;
  }
}

@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .item-card {
    width: 100%;
    min-height: 560px;
    height: 100%;
  }
  .or-line {
    width: 94%;
  }
  .login-page {
    height: 100%;
    align-items: center;
  }
  .xs-position-unset {
    position: unset !important;
  }

  .md-hidden {
    display: none;
  }
  .md-w-40 {
    width: 40% !important;
  }
  .xs-full-width {
    width: 40% !important;
  }
}
.rounded-card {
  border-radius: 15px;
}
@media only screen and (min-width: 1025px) and (max-width: 1795px) {
  .item-card {
    width: 60%;
  }
}
@media only screen and (min-width: 1796px) {
  .item-card {
    width: 50%;
  }
}
</style>
<style>
.v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
  -webkit-transform: unset;
  transform: unset;
}
</style>
